import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { globalStyles } from './style/gstheme';
import PrimaryButton from './PrimaryButton';

const styles = () => {
  return Object.assign({
    upgrade: {
      backgroundColor: '#13294B',
      color: 'white',
      borderRadius: 4,
      padding: 12,
      margin: '12px auto',
      maxWidth: '600px'
    }
  }, globalStyles);
};


class Upgrade extends Component {

  render() {

    const { classes } = this.props;

    return (
      <div className={classes.upgrade} data-test="upgrade">
        <Typography className={classes.mainHeading} style={{ color: 'white' }}>Consider Upgrading Your Subscription</Typography>
        <Typography paragraph variant="body2" style={{ color: 'white' }}>Higher levels of subscription allow you to do more</Typography>
        <a rel="noreferrer" href="https://graphologi.com/pricing" target="_blank">
          <PrimaryButton>View Options</PrimaryButton>
        </a>
      </ div>
    );

  }
}

Upgrade.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(Upgrade);